import * as React from 'react';
import FormModalContext from '../FormModalProvider/FormModal.context';
import { IFormModalConsumerProps } from './FormModalConsumer.types';

const FormModalConsumer: React.FC<IFormModalConsumerProps> = (
  props: IFormModalConsumerProps
) => {
  const { Consumer } = FormModalContext;
  const { pageNumber, children, className } = props;

  return (
    <Consumer>
      {actualPage =>
        actualPage === pageNumber ? (
          <div className={className ?? ''}>{children}</div>
        ) : null
      }
    </Consumer>
  );
};

export default FormModalConsumer;
